import { render, staticRenderFns } from "./picker-goods.vue?vue&type=template&id=2f12b566&"
import script from "./picker-goods.vue?vue&type=script&lang=js&"
export * from "./picker-goods.vue?vue&type=script&lang=js&"
import style0 from "./picker-goods.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports